import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import StoreDefinition from './StoreDefinition'

Vue.use(Vuex)

export default new Vuex.Store(new StoreDefinition().definition)